<script>
import Form, { formCreate } from '../../../../../../components/form';
import formAdd from './components';

formCreate.component('formAdd', formAdd);

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      rule: [],
      row: null,
      buttons: {
        submit: false,
      },
    };
  },
  async created() {
    const rule = await this.getFormRule('sfa_task_work_summary_detail');
    const newRule = [];
    rule.forEach((item) => {
      const v = item;
      if (v.field === 'form_add') {
        newRule.push({
          type: 'formAdd',
          field: 'form_add',
          title: '',
          value: {},
        });
      }
    });
    this.rule = newRule;
    this.reload(this.rule);
    this.formConfig.row.pictures.map((v) => {
      const item = v;
      item.imgList = [];
      item.imgList.push(item.picUrl + item.picPath);
      return item;
    });
    this.setValue({ form_add: this.formConfig.row });
  },

  methods: {
    // 提交
    submit() {
      this.$emit('onClose');
    },
  },
};
</script>
